import { Base64 } from "js-base64";

export const encryptText = (text: string, key: string): string => {
  let result = "";
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode);
  }

  return Base64.encode(result);
};

export const decryptText = (encryptedBase64: string, key: string): string => {
  const encryptedText = Base64.decode(encryptedBase64);

  let result = "";
  for (let i = 0; i < encryptedText.length; i++) {
    const charCode = encryptedText.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode);
  }

  return result;
};
